import React from 'react';
import { UtensilsCrossed, CalendarDays, CheckCircle, AlertTriangle, ReceiptText } from 'lucide-react';
import { Card, CardHeader, CardTitle } from '../ui/card';
import { JOURS_SEMAINE } from './cantineUtils';

// En-tete calque sur MaCaisse : bandeau bleu #246990, titre + icone,
// puis rangee de pastilles de statut.
const CantineHeader = ({ currentUser, joursService = [], autoriserRepasNonPaye }) => {
  const joursLabel = joursService.length === 0
    ? 'Aucun jour de service'
    : joursService
      .map((jour) => JOURS_SEMAINE.find((j) => j.value === jour)?.court)
      .filter(Boolean)
      .join(', ');

  return (
    <>
      <Card className="border-0 shadow-sm overflow-visible relative z-10">
        <CardHeader className="bg-[#246990] text-white rounded-t-lg overflow-visible">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <CardTitle className="flex items-center gap-3 text-2xl">
                <UtensilsCrossed size={30} />
                Cantine scolaire
              </CardTitle>
              <p className="text-white text-sm mt-1 font-semibold">
                Responsable : {currentUser?.nom} {currentUser?.prenom}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 mt-2">
            <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-white/15 text-white border border-white/30">
              <CalendarDays size={14} className="mr-1" />
              Service : {joursLabel}
            </span>

            {autoriserRepasNonPaye ? (
              <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-orange-500/20 text-white border border-white/30">
                <AlertTriangle size={14} className="mr-1" />
                Repas non payé autorisé
              </span>
            ) : (
              <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-green-500/20 text-white border border-white/30">
                <CheckCircle size={14} className="mr-1" />
                Paiement requis avant le repas
              </span>
            )}
          </div>
        </CardHeader>
      </Card>

      {/* Note d'information -- meme traitement que MaCaisse */}
      <div className="mt-6 p-4 bg-[#f9f0ee] rounded-lg border border-[#ae7467]/20 flex items-center">
        <div className="p-2 bg-[#ae7467] rounded-full mr-4">
          <ReceiptText className="text-white" size={20} />
        </div>
        <div className="flex-1">
          <h5 className="font-medium text-[#ae7467]">information importante</h5>
          <p className="text-sm text-gray-700 leading-relaxed">
            Ce module gère <strong>le service de restauration</strong> : qui est inscrit, qui a mangé, et ce qui est servi.
            <br /><br />
            La <strong>facturation reste inchangée</strong> : les abonnements mensuels et les repas ponctuels
            continuent de passer par la comptabilité existante et remontent dans la caisse.
            <span className="font-semibold text-[#ae7467]"> Le pointage ne crée aucun encaissement.</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default CantineHeader;
